<script>
  import { onMount } from 'svelte';
  import ClassDidNotHappenComponent from './ClassDidNotHappenComponent.svelte';
  import TeacherPerformanceRating from './TeacherPerformanceRating.svelte';
  import TeacherInvoiceComponent from './TeacherInvoiceComponent.svelte';
  import TeacherInfoComponent from './TeacherInfoComponent.svelte';
  import StudentInfoComponent from './StudentInfoComponent.svelte';
  import TeachersListComponent from './TeachersListComponent.svelte';
  import StudentsListComponent from './StudentsListComponent.svelte';
  import AdminFirstClassesNewTeachersComponent from './AdminFirstClassesNewTeachersComponent.svelte';

  import NavBarReusable from './NavbarReusable.svelte';

  // State for tab management
  let activeTab = 'incidents'; // 'incidents', 'performance', 'invoices', 'first-classes-new-teachers', 'teacher-info', 'student-info', 'teachers-list', or 'students-list'
  let deepLinkTeacherId = null;

  function switchTab(tab) {
    activeTab = tab;
  }

  function getHashParts() {
    const hash = window.location.hash || '#/teacherSurveilance';
    const qIndex = hash.indexOf('?');
    if (qIndex === -1) return { path: hash, params: new URLSearchParams() };
    return { path: hash.slice(0, qIndex), params: new URLSearchParams(hash.slice(qIndex + 1)) };
  }

  function readTabFromHash() {
    const { path, params } = getHashParts();
    if (!path.startsWith('#/teacherSurveilance')) return;
    const tab = params.get('tab');
    const teacherId = params.get('teacherId');
    if (tab) activeTab = tab;
    deepLinkTeacherId = teacherId ? parseInt(teacherId, 10) : null;
  }

  onMount(() => {
    readTabFromHash();
    const onHashChange = () => readTabFromHash();
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  });
</script>

<NavBarReusable label="Admin - Teacher Monitoring" />

<div class="calendar-launch"><a href="#/admin/calendar" target="_blank" rel="noopener noreferrer">Open Tutory Calendar</a></div>

<div class="tab-navigation">
  <button 
    class="tab-button {activeTab === 'incidents' ? 'active' : ''}"
    on:click={() => switchTab('incidents')}
  >
    Class Incidents
  </button>
  <button 
    class="tab-button {activeTab === 'first-classes-new-teachers' ? 'active' : ''}"
    on:click={() => switchTab('first-classes-new-teachers')}
  >
    First Classes with New Teachers
  </button>
  <button 
    class="tab-button {activeTab === 'performance' ? 'active' : ''}"
    on:click={() => switchTab('performance')}
  >
    Teacher Performance
  </button>
  <button 
    class="tab-button {activeTab === 'invoices' ? 'active' : ''}"
    on:click={() => switchTab('invoices')}
  >
    Teacher Invoices
  </button>
  <button 
    class="tab-button {activeTab === 'teacher-info' ? 'active' : ''}"
    on:click={() => switchTab('teacher-info')}
  >
    Teacher Information
  </button>
  <button 
    class="tab-button {activeTab === 'student-info' ? 'active' : ''}"
    on:click={() => switchTab('student-info')}
  >
    Student Information
  </button>
  <button 
    class="tab-button {activeTab === 'teachers-list' ? 'active' : ''}"
    on:click={() => switchTab('teachers-list')}
  >
    Teachers List
  </button>
  <button 
    class="tab-button {activeTab === 'students-list' ? 'active' : ''}"
    on:click={() => switchTab('students-list')}
  >
    Students List
  </button>
</div>

{#if activeTab === 'incidents'}
  <div class="classcontainer">
    <h3>Class Incident Reporting</h3>
    <ClassDidNotHappenComponent />
  </div>
{:else if activeTab === 'first-classes-new-teachers'}
  <div class="classcontainer">
    <h3>First Classes with New Teachers</h3>
    <AdminFirstClassesNewTeachersComponent />
  </div>
{:else if activeTab === 'performance'}
  <div class="classcontainer">
    <h3>Teacher Performance Rating</h3>
    <TeacherPerformanceRating embedded={!!deepLinkTeacherId} teacherId={deepLinkTeacherId} />
  </div>
{:else if activeTab === 'invoices'}
  <div class="classcontainer">
    <h3>Teacher Invoice Generation</h3>
    <TeacherInvoiceComponent />
  </div>
{:else if activeTab === 'teacher-info'}
  <div class="classcontainer">
    <h3>Teacher Information</h3>
    <TeacherInfoComponent embedded={!!deepLinkTeacherId} teacherId={deepLinkTeacherId} />
  </div>
{:else if activeTab === 'student-info'}
  <div class="classcontainer">
    <h3>Student Information</h3>
    <StudentInfoComponent />
  </div>
{:else if activeTab === 'teachers-list'}
  <div class="classcontainer">
    <h3>Teachers List</h3>
    <TeachersListComponent />
  </div>
{:else if activeTab === 'students-list'}
  <div class="classcontainer">
    <h3>Students List</h3>
    <StudentsListComponent />
  </div>
{/if}

<style>
  .calendar-launch { margin: 18px 0; }
  .calendar-launch a { display: inline-block; padding: 14px 24px; background: #273c75; color: white; text-decoration: none; border-radius: 12px; font-weight: 700; }
  .tab-navigation {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .tab-button {
    padding: 10px 20px;
    border: 1px solid #ccc;
    background: white;
    cursor: pointer;
    border-radius: 8px;
  }

  .tab-button.active {
    background: #fab45a;
    color: black;
    border-color: #fab45a;
  }

  .classcontainer {
    padding: 15px;
    background-color: white;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    gap: 10px;
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
    border-radius: 8px;
    flex: none;
    color: black;
    align-items: flex-start;
  }

  .classcontainer h3 {
    margin: 0 0 15px 0;
    color: #333;
  }

  /* Override nested component styles for cleaner integration */
  :global(.classcontainer .teacher-performance-rating) {
    max-width: none;
    margin: 0;
    padding: 0;
  }
</style>
